import { useDebouncedCallback } from "@react-hookz/web";
import { useAtom } from "jotai";

import { isDocumentBodyScrollLockedAtom } from "./atoms";

export const useDocumentBodyScrollLock = () => {
  const [_isDocumentBodyScrollLocked, setIsDocumentBodyScrollLocked] = useAtom(
    isDocumentBodyScrollLockedAtom,
  );

  const lockDocumentBodyScroll = useDebouncedCallback(
    (lock: boolean) => {
      setIsDocumentBodyScrollLocked(lock);
    },
    [],
    100,
  );

  return { lockDocumentBodyScroll };
};
